import { render } from "./PdfHzbaMaengelPage.vue?vue&type=template&id=395a99c6&scoped=true&ts=true"
import script from "./PdfHzbaMaengelPage.vue?vue&type=script&lang=ts"
export * from "./PdfHzbaMaengelPage.vue?vue&type=script&lang=ts"

import "./PdfHzbaMaengelPage.vue?vue&type=style&index=0&id=395a99c6&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395a99c6"]])

export default __exports__